/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import {__} from "language";
import {AllHtmlEntities} from "html-entities";
import getZxcvbn from "promise?global!zxcvbn";
import PropTypes from "prop-types";
import React, {Component} from "react";

const entitiesDecoder = new AllHtmlEntities();

export async function computePasswordStrength(password) {
  // zxcvbn().score from 0 to 4 if crack time is less than
  // 10**2, 10**4, 10**6, 10**8 or infinity.
  const zxcvbn = await getZxcvbn();

  return Math.min(zxcvbn(password).score, 4);
}

export function passwordStrengthToString(passwordStrength) {
  switch (passwordStrength) {
    case 1:
      return __("password::pwsWeak");

    case 2:
      return __("password::pwsGood");

    case 3:
      return __("password::pwsStrong");

    case 4:
      return __("password::pwsVeryStrong");

    default:
      return __("password::pwsTooWeak");
  }
}

export class PasswordStrengthIndicator extends Component {
  static propTypes = {
    getPasswordStrength: PropTypes.func,
    getPasswordStrengthString: PropTypes.func,
    password: PropTypes.string.isRequired,
  };

  static defaultProps = {
    getPasswordStrength: computePasswordStrength,
    getPasswordStrengthString: passwordStrengthToString,
  };

  render() {
    const {
      getPasswordStrength,
      getPasswordStrengthString,
      password,
      ...props,
    } = this.props;

    return (
      <span {...props}>
        {getPasswordStrengthString(getPasswordStrength(password))}
      </span>
    );
  }
}

export function decodeEntities(string) {
  return entitiesDecoder.decode(string);
}



// WEBPACK FOOTER //
// ../security.js